import { IPrinterViewModel } from '@printing/models';
import { Dpi, State } from '@shared/enums';
import { PrinterImageUrlHelper } from '@shared/util';

export class IUserPrinterViewModel {
	public id: number;
	public name: string;
	public serialNumber: string;
	public status: State;
	public displayName: string;
	public dpi: Dpi;
	public clientId: string;
	public locationName: string;
	public issueDescription?: string;
	public printerIdentifier: string;
	private printStationName: string;
	public printStationId: number;
	public printStationStatus: State;
	private locationType: string;
	private locationKey: string;

	public imgUrl?: string;

	constructor(printer: IPrinterViewModel) {
		this.id = printer.id;
		this.name = printer.name;
		this.serialNumber = printer.serialNumber;
		this.status = printer.status;
		this.displayName = printer.displayName;
		this.dpi = printer.dpi;
		this.clientId = printer.clientId;
		this.locationName = printer.locationName;
		this.printStationName = printer.printStationName;
		this.printStationId = printer.printStationId;
		this.printStationStatus = printer.printStationStatus;
		this.locationType = printer.locationType;
		this.locationKey = printer.locationKey;
		this.imgUrl = PrinterImageUrlHelper.getImageUrl(printer.name);
		this.issueDescription = printer.issueDescription;
		this.printerIdentifier = printer.clientId + printer.serialNumber;
	}
}
